import { Component, inject, OnInit } from '@angular/core';
import { OrderContextService } from '../../services/order-context.service';

import { Router, ActivatedRoute } from '@angular/router';
import { SimplifiedOrderContext } from '../../models/simplifiedOrderContext';
import { Subscription } from 'rxjs';
import { interval } from 'rxjs';
import { first, startWith, switchMap } from 'rxjs';
import { CartService } from '../../services/cart/cart.service';

@Component({
    selector: 'lib-order-confirmation',
    templateUrl: './order-confirmation.component.html',
    styleUrls: ['./order-confirmation.component.css'],
    standalone: false
})
export class OrderConfirmationComponent implements OnInit {
  protected orderContextService = inject(OrderContextService);
  protected router = inject(ActivatedRoute);
  protected cartService = inject(CartService);
  public context?: SimplifiedOrderContext;
  

  timeInterval: Subscription;
  public error?: any;
  public processing = true;
  public stripe: boolean;
  public cardPaymentStatus: boolean;


  ngOnInit() {
    const contextId = this.router.snapshot.params.contextId;
    const stripe = this.router.snapshot.queryParams.stripe;
    const cardPaymentStatus = this.router.snapshot.queryParams.cardPaymentStatus;
    this.stripe = stripe === 'success';
    this.cardPaymentStatus = cardPaymentStatus === 'success';

    if(this.cardPaymentStatus){
      this.cartService.clearCart();
    }

    this.timeInterval = interval(1000)
      .pipe(
        startWith(0),
        switchMap(() => this.orderContextService.getSimplifiedOrderContext(contextId)),
        first(e => this.isOrderFinalized(e))
      )
      .subscribe(
        context => {
          this.processing = false;
          this.context = context;
          console.log('context', context);
        },
        err => {
          console.log('err', err);
        }
      );
  }

  protected isOrderFinalized(context: SimplifiedOrderContext): boolean {
    return context.finalized || (context.erpOrderIds && context.erpOrderIds.length > 0);
  }
}
